module.exports = __webpack_public_path__ + "img/pkg-img.480bdf16.svg";